import photo from "../assets/images/fotoperfil.png";

const profileImages = {
    profile: photo
}

export { profileImages };
